import type { FC, PropsWithChildren } from 'react';

import { BotChip } from '~components/BotChip';
import { H1 } from '~components/Typography';
import { useCurrentBot } from '~hooks/useCurrentBot';
import { ImageRenderer } from '~shared/ui/molecules';

import TextIcon from '../../../../../public/assets/text-icon.svg';
import type { TBotFullPageCard } from '../../model/types';
import {
	BotContent,
	BotImage,
	CardWrapper,
	PromoBlockBottom,
	PromoBlockHead,
} from './styles';

export const BotFullPageCard: FC<PropsWithChildren & TBotFullPageCard> = ({
	botId,
	promo,
	showImage = true,
	children,
}) => {
	const { bot, botSuccess } = useCurrentBot({ recipientId: botId });
	const hasImage = !!bot?.images?.webBackgroundPath;
	if (!botSuccess) {
		return null;
	}

	return (
		<CardWrapper className={promo ? 'promo' : ''}>
			{promo ? (
				<>
					<PromoBlockHead>
						<TextIcon width={82} height={40} />
						<H1 align="left" transform="uppercase">
							Jump into your desires
						</H1>
					</PromoBlockHead>
					<PromoBlockBottom>
						<BotChip
							avatar={bot?.images?.chatAvatarLinks}
							fallback={bot?.images?.chatAvatarPath ?? ''}
							name={bot.name}
							text="Celebrity"
						></BotChip>
					</PromoBlockBottom>
				</>
			) : null}
			{hasImage && showImage ? (
				<BotImage>
					<ImageRenderer
						item={bot.images.webBackgroundLinks}
						fallback={bot.images.webBackgroundPath ?? ''}
						quality={100}
						alt={bot.name}
						fill={true}
						sizes="(max-width: 500px) 350px, (max-width: 768px) 440px, 600px"
					/>
				</BotImage>
			) : null}
			<BotContent>{children}</BotContent>
		</CardWrapper>
	);
};
